/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FCS API
 * Field Compliance System — REST API
 * OpenAPI spec version: 0.0.54-SNAPSHOT
 */
import type {
  GetTeamDiagnosesParams,
  GetVendorSummariesParams,
  TeamDiagnosisDto,
  VendorSummaryDto
} from '../model';

import { customInstance } from '../../mutator/custom-instance';



  export const getTeams = () => {
/**
 * Returns all completed diagnoses performed by team members for the specified store,
 * team, and period. Each diagnosis includes the vendor who performed it, the product
 * family, the compliance score, and days remaining until expiration. Used by team
 * leaders to monitor overall team compliance performance.
 * @summary Get all team diagnoses for a store/team over a period
 */
const getTeamDiagnoses = (
    storeId: number,
    teamId: number,
    params: GetTeamDiagnosesParams,
 ) => {
      return customInstance<TeamDiagnosisDto[]>(
      {url: `/api/v1/stores/${storeId}/teams/${teamId}/diagnoses`, method: 'GET',
        params
    },
      );
    }
  /**
 * Returns aggregated diagnosis statistics for each vendor in the specified store/team
 * over the given period. Each summary includes the vendor's user ID, count of completed
 * diagnoses, and average compliance score. Used by team leaders to monitor individual
 * vendor performance and identify training needs.
 * @summary Get vendor diagnosis summaries for a store/team over a period
 */
const getVendorSummaries = (
    storeId: number,
    teamId: number,
    params: GetVendorSummariesParams,
 ) => {
      return customInstance<VendorSummaryDto[]>(
      {url: `/api/v1/stores/${storeId}/teams/${teamId}/vendors_summaries`, method: 'GET',
        params
    },
      );
    }
  return {getTeamDiagnoses,getVendorSummaries}};
export type GetTeamDiagnosesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTeams>['getTeamDiagnoses']>>>
export type GetVendorSummariesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTeams>['getVendorSummaries']>>>
